import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker — makes the app fully installable (standalone, app-like) on
// iOS and Android AND guarantees the latest version is always served. The SW
// (public/sw.js) is network-only for HTML so it can NEVER revert to an old
// build; it only caches immutable hashed /static/ assets. On a new deploy the
// new SW activates and we reload once so users always get the freshest version.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Capture whether a SW already controls this page. We only auto-reload on an
    // UPDATE (a controller already existed) — not on the very first activation.
    const hadController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        reg.update().catch(() => {});
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            // New SW installed while an old one still controls → activate it now.
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              installing.postMessage?.({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {});

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing || !hadController) return; // skip the first-ever claim
      refreshing = true;
      window.location.reload();
    });
  });
}
